import {
  AppstoreOutlined,
  BarsOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import { Empty, Input, Table, Tooltip } from "antd";
import React, { Component } from "react";
import AdqDetailGridNew from "../AdqGrid/adqGrid";
import { isMobile } from 'react-device-detect';
let selectedRowKeys = [];
let selectedObjects = [];

class AdqDetailListNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: props.detailsListData,
      updateTable: [],
      keyDataNoJson: props.keyDataNoJson,
      listofsearchData: JSON.stringify(props.detailsListData),
      title: props.detailsListConfig.title,
      screenType: props.detailsListConfig.screenType
        ? props.detailsListConfig.screenType
        : "",
      type: props.detailsListConfig.type,
      isSearchable: props.detailsListConfig.isSearch,
      isColumChooser: props.detailsListConfig.isColumChooser,
      pagination: props.detailsListConfig.pagination,
      isExpendable: props.detailsListConfig.isExpendable,
      TBLColumn: props.columns,
      loading: false,
      showDropdownDetails: false,
      KeysData: [],
      filteredValue: "",
      isColumnsBind: true,
      isCurrentPage: 1,
      isPageSize: 10,
      searchResult: null,
      isChildren: props.detailsListConfig.isChildren,
      isGridView: props.detailsListConfig.isGridView,
      isSelectAll: props.detailsListConfig.isSelectAll ? props.detailsListConfig.isSelectAll : false,
      gridMode: isMobile && props.detailsListConfig.isDefaultCardView !== false ? true : false,
      FilteredInfo: {},
      SortedInfo: {},
      disableCheck: false,
      searchValue:"",
      prevDetailsListData: [],
    };
  }

  invoiceMorePages = () => {
    this.setState({ showDropdownDetails: !this.state.showDropdownDetails });
  };
  changeViewMode = () => {
    this.props.detailsListData.forEach((keyName, index) => {
      if (keyName.groupList) {
        keyName.children = keyName.groupList;
      }
    });
    this.setState({ gridMode: !this.state.gridMode, tableData: JSON.stringify(this.props.detailsListData), TBLColumn: this.props.columns, });
  };

  static getDerivedStateFromProps(props, state) {
    if (props.detailsListData !== state.detailsListData) {
      return {
        tableData:
          state.updateTable.length === props.detailsListData.length
            ? props.detailsListData
            : state.updateTable.length > 0
              ? state.updateTable
              : props.detailsListData,
        listofsearchData: JSON.stringify(props.detailsListData),
        isSearchable: props.detailsListConfig.isSearch,
        isColumChooser: props.detailsListConfig.isColumChooser,
        pagination: props.detailsListConfig.pagination,
        TBLColumn: props.columns,
        isChildren: props.detailsListConfig.isChildren,
      };
    }
  }
// static getDerivedStateFromProps(props, state) {

//   if (props.detailsListData !== state.prevDetailsListData) {

//     return {
//       prevDetailsListData: props.detailsListData,
//       tableData: JSON.parse(
//         JSON.stringify(props.detailsListData || [])
//       ),
//       listofsearchData: JSON.stringify(props.detailsListData || []),
//       isSearchable: props.detailsListConfig.isSearch,
//       isColumChooser: props.detailsListConfig.isColumChooser,
//       pagination: props.detailsListConfig.pagination,
//       TBLColumn: props.columns,
//       isChildren: props.detailsListConfig.isChildren,
//     };
//   }

//   return null;
// }
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.detailsListData && this.props.detailsListData.length > 0) {
      if (
        prevProps.detailsListData !== this.props.detailsListData &&
        prevState.isColumnsBind === true
      ) {
        if (this.state.updateTable) {
          var KeysArray = [];
          let TBLColumn = this.state.TBLColumn;
          let keyValue = this.state.TBLColumn;
          let newKeyValues = keyValue.map((keyName, index) => {
            if(keyName !== "" && keyName !== undefined && keyName !== false){
            keyName["isChecked"] = true;
            return keyName
            }
          });
          KeysArray =   newKeyValues.filter((x) => x !== undefined);
          this.setState(
            { TBLColumn: TBLColumn, KeysData: KeysArray, isColumnsBind: false }
          );
        }
      }
    }
  };

  handleOnChange = (e, i, list) => {
    let columnsData = this.state.TBLColumn;
    let keyValueString = JSON.stringify(this.state.KeysData);
    let keyvalues = JSON.parse(keyValueString);
    for (var i = 0; i < keyvalues.length; i++) {
      if (keyvalues[i].dataIndex === list.dataIndex) {
        if (e.target.checked) {
          keyvalues[i].isChecked = e.target.checked;
          columnsData[i].hide = false;
        } else {
          if (columnsData.length > 3) {
            keyvalues[i].isChecked = false;
            for (var i = 0; i < columnsData.length; i++) {
              if (columnsData[i].dataIndex === list.dataIndex) {
                columnsData[i].hide = true;
              }
            }
          }
        }
      }
    }
    if (keyvalues.filter((a) => a.isChecked === true).length <= 3) {
      this.setState({ disableCheck: true })
    }
    else {
      this.setState({ disableCheck: false })
    }
    this.setState({ KeysData: keyvalues, TBLColumn: columnsData }, () => {
    });
  };

  // onTableChange = (pagination, filters, sorter) => {
  //   this.setState({
  //     isCurrentPage: pagination.current,
  //     isPageSize: pagination.pageSize,
  //     FilteredInfo: filters,
  //     SortedInfo: sorter
  //   });
  //   requestAnimationFrame(() => {
  //     const tableContent = document.querySelector('.ant-table-content');
  //     if (tableContent) {
  //       tableContent.scrollTop = 0;
  //     }
  //   });
  //   this.props.onPagenationChange(pagination);
  // };

  onTableChange = (pagination, filters, sorter) => {
    const normalize = (f) => Object.fromEntries(
      Object.entries(f).filter(([_, v]) => v !== null && v !== undefined && v.length !== 0)
    );
    const filtersChanged = JSON.stringify(normalize(filters)) !== JSON.stringify(normalize(this.state.FilteredInfo));
    this.setState({
      isCurrentPage: pagination.current,
      isPageSize: pagination.pageSize,
      FilteredInfo: filters,
      SortedInfo: sorter
    });
    requestAnimationFrame(() => {
      const tableContent = document.querySelector('.ant-table-content');
      if (tableContent) {
        tableContent.scrollTop = 0;
      }
    });
    // this.props.onPagenationChange(pagination);
    // if (this.props.onFilterApply) {
    //   this.props.onFilterApply(filters);
    // }

    if (filtersChanged) {
      // filter OK clicked — call filter handler only
      if (this.props.onFilterApply) {
        this.props.onFilterApply(filters);
      }
    } else {
      // page/size changed — call pagination handler only
      this.props.onPagenationChange(pagination);
    }
  };

  tableLength = (array) => {
    let uniq = {};
    var lengthobj = array.filter(
      (obj) => !uniq[obj.id] && (uniq[obj.id] = true)
    );
    return lengthobj.length;
  };

  uniquefilterObjects = (data, key) => {
    let listofItems = data.map((x) => x[key]);
    if (listofItems.length > 0) {
      let UniqueValues = listofItems.filter(
        (item, index) => listofItems.indexOf(item) === index
      );
      if (UniqueValues.length > 0) {
        let Array = [];
        UniqueValues.forEach((item) => {
          if (item !== null && item !== undefined) {
            let obj = { text: item, value: item };
            Array.push(obj);
          }
        });

        return Array;
      }
    }
  };

  clearAllFilter = () => {
    this.setState({ FilteredInfo: {}, SortedInfo: {} }, () => { });
  }

  render() {
    const {
      tableData,
      TBLColumn,
      loading,
      title,
      pagination,
      isSearchable,
      isColumChooser,
      KeysData,
      type,
      isExpendable,
      isSelectAll,
      gridMode,
      isGridView,
      keyDataNoJson
    } = this.state;
    let Tdata1 = TBLColumn?.filter((x) => x.hide === false);
    const KeysDataNew = keyDataNoJson ? KeysData : JSON.parse(JSON.stringify(KeysData));
    const Tdata = Tdata1.map(column => {
      if (column.dataIndex === 'itemName') {
        return { ...column, title:(<span style={{
          width: '170px',
          display: 'block',          
          wordBreak: 'break-word',
          whiteSpace: 'normal'
        }}>
          {column.title}
        </span>) };
      }
      return column;
    });
    const onSelectChange = {
      onSelect: (e) => {
        let index = selectedRowKeys.findIndex(x => x === e.id);
        if (index !== -1) {
          selectedRowKeys.splice(index, 1);
          selectedObjects.splice(index, 1)
        } else {
          selectedRowKeys.push(e.id)
          selectedObjects.push(e)
        }
        this.props.selectedRecords(selectedObjects);
      },
      onSelectAll: (e) => {
        if (e === false) {
          selectedRowKeys = [];
          selectedObjects = [];
        } else {
          selectedRowKeys = tableData.map(x => x.id);
          selectedObjects = tableData;
        }
        this.props.selectedRecords(selectedObjects);
      }
    };

    let keys = Tdata.map((x) => x.dataIndex);
    if (keys.length > 0) {
      keys.forEach((e) => {
        let index = Tdata.findIndex(
          (x) =>
            x.dataIndex === e &&
            !x.nofilter &&
            x.title !== "Action" &&
            x.title !== "Select" &&
            x.title !== "Read" &&
            x.title !== "Write" &&
            x.title !== "Delete" &&
            x.title !== "#" &&
            x.dataIndex !== 'sync',
        );
        if (index !== -1) {
          Tdata["ellipsis"] = true;


          Tdata[index]["filters"] = Tdata[index].staticFilters
            ? Tdata[index].staticFilters
            : this.uniquefilterObjects(tableData, e);
          Tdata[index]["filterSearch"] = true;

          if (Tdata[index].staticFilters) {
            // server-side filtering — skip onFilter so table shows all returned records as-is
            delete Tdata[index]["onFilter"];
          } else {
            Tdata[index]["onFilter"] =
              (value, record) => {
                console.log("Selected Filter Value:", value, "| Column:", e);
                if (this.props.onFilterChange) {
                  this.props.onFilterChange(value, e);
                }
                if (record[e] !== null && record[e] !== undefined) {
                  return record[e].toString().includes(value.toString());
                }
              }
          }
          // Tdata[index]["filters"] = Tdata[index].staticFilters
          //   ? Tdata[index].staticFilters
          //   : this.uniquefilterObjects(tableData, e);
          // Tdata[index]["filterSearch"] = true;
          // Tdata[index]["onFilter"] =
          //   (value, record) => {
          //     console.log("Selected Filter Value:", value, "| Column:", e);
          //     if (record[e] !== null && record[e] !== undefined) {
          //       return record[e].toString().includes(value.toString());
          //     }
          //   }

          // Tdata[index]["onFilter"] =
          //   (value, record) => {
          //     // console.log("Selected Filter Value:", value, "| Column:", e);
          //     if (this.props.onFilterChange) {
          //       this.props.onFilterChange(value, e);
          //     }
          //     if (record[e] !== null && record[e] !== undefined) {
          //       return record[e].toString().includes(value.toString());
          //     }
          //   }


          // Tdata[index]["filteredValue"] = this.state.FilteredInfo[Tdata[index].dataIndex] || null
          // 2  Tdata[index]["filters"] = this.uniquefilterObjects(tableData, e);
          //  3 Tdata[index]["filterSearch"] = true;
          // 4  Tdata[index]["onFilter"] =
          //  5   (value, record) => {
          //   6    if (record[e] !== null && record[e] !== undefined) {
          //    7     return record[e].toString().includes(value.toString());
          //         //  return record[e].toLowerCase().includes(value.toLowerCase());
          //    8   }
          //    9 }
          // (value, record) =>
          //   record[e].toString().includes(value.toString());
        }
      });
    }

    return (
      <div className="mt-1">
        {tableData ? (
          <div className="tableSearchPosition">
            {/* Optional caller-supplied note, rendered inside the white card
                above the title. Nothing renders when the prop is omitted. */}
            {this.props.headerNote}
            <div className={title !== "" ? "header hedname" : "d-none"}>
              <h4 className="pl-1 fx-none main_heading">{title}</h4>
            </div>{title === "Applied Credit" || title === "Applied Debit" || title === "Payment Received"? <br /> : ''}
            {
              true && (
                <div className="d-flex">
                  {isSearchable && (
                    <div className="searchClass col-md-3 ml-auto mb-3"
                      id="addDetailListSearch">
                      <Input.Search
                        allowClear={true}
                        placeholder="Search by..."
                        enterButton
                        // onSearch={() => {
                          // this.setState(
                          //   { showSearchBox: !this.state.showSearchBox },
                          //   () => { }
                          // );
                        // }}                       
                        onSearch={(value) => {
                          this.props.handleListSearch(value)
                        }}
                      />
                    </div>
                  )}
                  {isColumChooser && KeysDataNew.length > 0 && (
                    <div
                      className={
                        !isSearchable
                          ? "colmunChooser px-1 pt-2 ml-auto"
                          : "colmunChooser px-1 pt-2"
                      }
                    >
                      <p
                        className="columnChooserSec"
                        style={
                          type === "MultiReport"
                            ? { float: "right", marginTop: "-33px" }
                            : { float: "right" }
                        }
                      >
                        <Tooltip title='Choose Columns'>
                          <DatabaseOutlined />
                        </Tooltip>
                        <div className="customDropdownBtnDetails menu">
                          <ul>
                            {KeysDataNew.length > 0
                              ? KeysDataNew.map((list, i) => {
                                return (
                                  <li key={i}>
                                    <input
                                      id={list.title + i}
                                      type="checkbox"
                                      style={{
                                        height: "14px",
                                        width: "14px",
                                      }}
                                      disabled={list.disable ? list.disable : this.state.disableCheck ? list.isChecked : this.state.disableCheck}
                                      checked={list.isChecked}
                                      onChange={(e, i) =>
                                        this.handleOnChange(e, i, list)
                                      }
                                    />
                                    <label
                                      style={{
                                        marginLeft: "6px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {list.title}
                                    </label>
                                  </li>
                                );
                              })
                              : ""}
                          </ul>
                        </div>
                      </p>
                    </div>
                  )}
                  {
                    <div
                      className={
                        !isSearchable
                          ? "colmunChooser px-1 pt-2 ml-auto"
                          : "colmunChooser px-1 pt-2 indx-0"
                      }
                    >
                      <p
                        style={
                          type === "MultiReport"
                            ? { float: "right", marginTop: "-33px" }
                            : { float: "right" }
                        }
                      >
                        {gridMode ? (
                          <Tooltip title="Grid View" className="columnChooserSec">
                            <BarsOutlined onClick={this.changeViewMode} />
                          </Tooltip>
                        ) : isGridView ? (
                          <Tooltip title="Card View" className="colmunChooser">
                            <AppstoreOutlined onClick={this.changeViewMode} />
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                  }
                  <div className="colmunChooser">
                    {/* <p style={{ marginTop: "5px", marginLeft: "4px" }}>
                        <span>
                          <MdFilterAltOff onClick={this.clearAllFilter} />
                        </span>
                      </p> */}
                  </div>
                </div>
              )
            }
            <div className="px-1">
              {Tdata.length > 0 && tableData.length > 0 ? (
                gridMode == true ? (
                  <span>
                    <AdqDetailGridNew
                      columns={Tdata}
                      dataSource={tableData}
                      pagination={
                        pagination === true
                          ? {
                            defaultPageSize: 9,
                            total: this.props.totalCount !== 0 ? this.props.totalCount : tableData.length,
                            showSizeChanger: true,
                            // showQuickJumper: true,
                            pageSizeOptions: ["9", "10", "20", "30", "40", "50", "100", "200"],
                          }
                          : pagination
                      }
                    ></AdqDetailGridNew>
                  </span>
                ) : isSelectAll === false ? (
                  <span>
                    <Table
                      bordered
                      columns={Tdata}
      rowKey={(record, index) =>
    record.lineId ||
    record.id ||
    record.key ||
    index
  }
                      dataSource={tableData}
                      loading={loading}
                      defaultExpandAllRows={isExpendable}
                      rowClassName={(record) => {
                        if (record.activeRow === true || record.partyName === "Party Total" ||record.partyName === "Invoice Total"||record.partyName === "Bill Total"|| record.partyName === "Grand Total" || record.particulars === "Total" ||record.uom === "Total" ||record.uomCode === "Total"||record.status === "Total"||record.salesmanName ==="Total"||record.salesmanName ==="Grand Total"||record.physicalLocation === "Grand Total") {
                          return "activeRow";
                        } else if(record.RedactiveRow === true ){
                          return "RedactiveRow";
                        }else{
                          return ""
                        }
                      }}
                      pagination={
                        pagination === true
                          ? {
                            defaultPageSize: 10,
                            total: this.props.totalCount !== 0 ? this.props.totalCount : tableData.length,
                            showSizeChanger: true,
                            // showQuickJumper: true,
                            pageSizeOptions: [
                              "10",
                              "20",
                              "30",
                              "40",
                              "50",
                              "100",
                              "200",
                            ],
                          }
                          : pagination
                      }
                      onChange={this.onTableChange}
                    />
                    {pagination && (
                      <div className="tableRecordsCount tableRecordsCount1">
                        Page <b>{this.state.isCurrentPage}</b> of{" "}
                        <b>{this.state.isPageSize}</b>{" "}
                        {this.props.totalCount ? <b>({this.props.totalCount} items)</b> :
                          <b>({this.props.detailsListData.length} items)</b>}
                      </div>
                    )}
                  </span>
                ) : isSelectAll === true ? (
                  <span>
                    <Table
                      bordered
                      columns={Tdata}
                      rowKey={(record) => record.id}
                      rowSelection={onSelectChange}
                      dataSource={tableData}
                      loading={loading}
                      defaultExpandAllRows={isExpendable}
                      rowClassName={(record) => {
                        if (record.activeRow === true || record.PartyName === "Party Total" || record.partyName === "Grand Total" || record.particulars === "Total" ||record.uom === "Total"||record.physicalLocation === "Grand Total") {
                          return "activeRow";
                        } else {
                          return "";
                        }
                      }}
                      pagination={
                        pagination === true
                          ? {
                            defaultPageSize: 10,
                            total: this.props.totalCount !== 0 ? this.props.totalCount : tableData.length,
                            showSizeChanger: true,
                            // showQuickJumper: true,
                            pageSizeOptions: [
                              "10",
                              "20",
                              "30",
                              "40",
                              "50",
                              "100",
                              "200",
                            ],
                          }
                          : pagination
                      }
                      onChange={this.onTableChange}
                    />
                    {pagination && (
                      <div className="tableRecordsCount tableRecordsCount1">
                        Page <b>{this.state.isCurrentPage}</b> of{" "}
                        <b>{this.state.isPageSize}</b>{" "}
                        <b>({this.tableLength(tableData)} items)</b>
                      </div>
                    )}
                  </span>
                ) : ''
              ) : (
                <div className="px-1">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="my-5 py-5"
                    description={
                      <span className="text-center">
                        <b>No Data</b><br />
                      </span>
                    }
                  />
                </div>
              )}
              {tableData.length === 0 ? <br /> : ""}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default AdqDetailListNew;
